export default __webpack_public_path__ + "static/media/feature1_3.61d4090f.png";